export default __webpack_public_path__ + "static/media/expandFullscreen.245d0d81.svg";